'use client'
import { useViewport } from '@/components/findex-connect/hooks/useViewport'
import { Section } from '@/components/findex-connect/store/ThemeStore'
import { FeatureSb, HeroBlockSb } from '@/components/findex-connect/types/component-types-sb'

import { BlurryLightsNight } from '../BlurryLights/BlurryLightsNight'
// import { JotformPanel } from "../JotformPanel/JotformPanel"
import { HubspotPanel } from '../HubspotPanel/HubspotPanel'
import { ArrowIcon } from '../Icons/ArrowIcon/ArrowIcon'
import { TickIcon } from '../Icons/TickIcon/TickIcon'

type HeroBlockProps = {
  sectionId: Section
  data: HeroBlockSb
}

const STATIC_DATA = {
  CTAs: [
    {
      text: 'Explore Services',
      url: '#services',
    },
    {
      text: 'Why Findex',
      url: '#why-findex',
    },
  ],
}

export const HeroBlock: React.FC<HeroBlockProps> = ({ sectionId, data }) => {
  const { viewportWidth } = useViewport()

  const { features, headerText, headerTagText, mainText } = data || {
    features: [],
    headerText: '',
    headerTagText: '',
    mainText: '',
    CTAs: [],
  }

  const renderFeatureText = (feature: FeatureSb) => {
    const { text, numberOfBoldWords } = feature
    const number = parseInt(numberOfBoldWords)
    const words = text?.split(' ')
    const boldWords = words?.slice(0, number)
    const remainingWords = words?.slice(number)
    const boldText = boldWords?.join(' ')
    const remainingText = remainingWords?.join(' ')
    return (
      <span className="text-white">
        <strong>{boldText} </strong> {remainingText}
      </span>
    )
  }

  return (
    <div className="HEROBLOCK-CONTAINER w-full" id={sectionId}>
      <BlurryLightsNight />
      <div className="HEROBLOCK-INNER max-w-container p-gutter mx-auto flex flex-col gap-3 py-12 lg:flex-row">
        <div className="HEROBLOCK-LEFT w-full shrink-0 grow-1 flex-col gap-6 pl-0 md:gap-12 lg:w-1/2 lg:pl-10 xl:w-1/2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 160 52"
            width="160"
            height="52"
            className="mb-6 h-auto w-[160px] md:mb-12"
          >
            <path
              d="M150.86 13.51c.09.16.29.22.46.14.06-.03.1-.07.13-.13l7.7-12.68c.11-.19.1-.42-.02-.59a.57.57 0 0 0-.48-.24h-5.89a.26.26 0 0 0-.26.21s.07 1.17-.4 2.13c-.47.96-3.57 6.87-3.57 6.87-.05.11-.05.24 0 .34l2.34 3.95Zm8.78 21.86-8.37-14.1c-.09-.14-.27-.19-.41-.1-.04.03-.08.06-.1.1l-2.34 3.87c-.21.34-.21.59-.02.94l5.52 9.54c.1.17.28.28.48.28h4.95c.19 0 .35-.15.35-.34 0-.06-.02-.12-.05-.18Zm-10.67-17.05c.19-.32.19-.72.01-1.05C147.37 14.34 139.63.3 139.63.3a.564.564 0 0 0-.49-.29h-5.67c-.19 0-.34.15-.34.34 0 .06.01.12.05.18l10.02 16.85c.04.06.04.14 0 .21l-10.53 17.46c-.12.19-.11.43.02.61.11.15.29.24.47.24h5.28c.2 0 .39-.11.49-.28l10.03-17.29ZM19.43 5.21a4.8 4.8 0 0 0 4.8-4.79c0-.22-.19-.41-.41-.41h-23C.66 0 .52.12.52.28v.09c.21 1.07.64 3.13.64 5.08v27.18c0 .9-.49 3.05-.49 3.05-.02.09.04.19.13.2h5.59c.29 0 .52-.23.52-.51v-15.9h13.08c.42 0 .77-.29.87-.69l.92-3.87a.528.528 0 0 0-.39-.63c-.04 0-.08-.01-.12-.01H6.9V5.21h12.53ZM34.96 0h-5.58c-.16 0-.3.11-.31.27v.1c.21 1.07.62 3.08.64 5.01v29.98c0 .29.23.52.51.52h4.71c.29 0 .52-.23.52-.51V.5c0-.27-.21-.49-.49-.49Zm66.89 13.86c-.01-1.25-.12-2.51-.33-3.75-.21-1.22-.57-2.41-1.07-3.54-.51-1.14-1.26-2.21-2.23-3.17a10.532 10.532 0 0 0-4.1-2.56C92.54.29 90.79.01 88.91.01H75.93c-.16 0-.3.11-.31.27v.1c.21 1.07.64 3.12.64 5.07v29.92c0 .29.23.52.51.52h12.15c1.88 0 3.63-.28 5.2-.82 1.55-.53 2.95-1.41 4.11-2.56.95-.93 1.71-2.04 2.24-3.26.5-1.18.86-2.41 1.06-3.68.21-1.3.31-2.6.33-3.91.01-1.34.02-2.66.02-3.94s0-2.56-.02-3.85Zm-5.97 10.29c-.16 1.8-.71 3.22-1.6 4.2-1.43 1.55-3.42 2.33-5.92 2.33h-5.91c-.25 0-.45-.2-.45-.45V5.73c0-.29.23-.52.51-.52h5.86c2.51.01 4.5.81 5.92 2.35.9.99 1.44 2.32 1.6 3.95.17 1.67.26 3.75.26 6.2 0 2.43-.09 4.6-.26 6.44Zm32.32 6.54h-15.53a.09.09 0 0 1-.09-.09V19.58c0-.06.05-.11.11-.11h11.88c.4 0 .75-.28.84-.67l.93-3.9a.518.518 0 0 0-.39-.62c-.04 0-.08-.01-.11-.01h-13.08c-.09 0-.17-.08-.17-.17V5.39c0-.09.08-.17.17-.17h11.57c2.35 0 4.52-2.03 4.52-4.52 0-.39-.18-.68-.73-.68h-21.6c-.17 0-.3.11-.31.27v.1c.22 1.07.63 3.11.64 5.06v29.93c0 .29.23.52.51.52h19.89c.26 0 .48-.18.54-.43l.89-4.21a.471.471 0 0 0-.37-.56h-.09ZM69.16 0h-5.45c-.16 0-.3.14-.3.3 0 0 .53 2.05.53 3.38v20.13L47.46 1.92l-.87-1.2c-.37-.47-.86-.67-1.43-.72h-2.91c-.16 0-.3.11-.31.27v.1c.21 1.07.64 3.12.64 5.06v29.93c0 .29.23.52.51.52h4.71c.29 0 .52-.23.52-.51V13.03l15.42 20.93c.16.24.34.47.54.69l.53.67c.28.35.7.56 1.15.56h3.21c.29 0 .52-.23.52-.51V.52c0-.29-.24-.52-.52-.52Z"
              fill="#fff"
            />
            <path
              d="M68.93 51.45H1.76C.79 51.45 0 50.66 0 49.7s.79-1.76 1.75-1.76h67.18c.97 0 1.75.79 1.75 1.76s-.78 1.75-1.75 1.75Z"
              fill="#d43d27"
            />
          </svg>

          <p className="HEADER-TAG text-eyebrows text-subtle-light mb-12 hidden md:block">
            {headerTagText}
          </p>
          <h1 className="MAIN-HEADING text-prominent-light mb-6">{headerText}</h1>
          <p className="MAIN-TEXT para-lg text-text-light w-full md:w-3/4 lg:w-full">{mainText}</p>
          <ul className="FEATURE-LIST flex flex-col gap-y-4 pt-10">
            {features?.map((feature) => (
              <li className="textblock-md text-text-light flex gap-4" key={feature.text}>
                <TickIcon /> {renderFeatureText(feature)}
              </li>
            ))}
          </ul>
          <div className="CTA-CONTAINER xs:justify-start mt-10 flex flex-wrap gap-4 max-[480px]:justify-between md:gap-4">
            {STATIC_DATA?.CTAs?.map((CTA, index) => (
              <a
                href={CTA.url}
                onClick={(event) => {
                  if (CTA.url.includes('#')) {
                    event.preventDefault()
                    window.scrollTo({
                      top:
                        (viewportWidth > 1023 ? 800 : 0) +
                        (document?.getElementById(CTA.url.replace('#', ''))?.offsetTop || 0),
                      behavior: 'smooth',
                    })
                  }
                }}
                className="CTA-BUTTON group tab-outline-primary group hover flex cursor-pointer items-center gap-2 text-sm font-bold whitespace-nowrap text-white uppercase !no-underline hover:no-underline focus:rounded-2xl md:mr-10 md:w-[166px]"
                key={CTA.text}
              >
                <ArrowIcon direction="down" outline fill="white" id={`arrow-${index}`} />
                <span className="group-hover:text-primary-dark transition-all duration-100 ease-in-out group-hover:ml-[3px]">
                  {CTA.text}
                </span>
              </a>
            ))}
          </div>
        </div>
        <div className="HEROBLOCK-JOTFORM lg:scale-90 lg:py-0 lg:pl-0 xl:scale-100 xl:pl-20">
          {/* <JotformPanel /> */}
          <HubspotPanel />
        </div>
      </div>
    </div>
  )
}
